import React from "react";
import { useSelector } from "react-redux";

import { selectTimestampDate } from "../../../app/state/view/timeline/TimelineSelectors";

import { TimelineMarker } from "./TimelineMarker";

export const TopologyTimeMarker: React.FC = () => {
	const timestamp = useSelector(selectTimestampDate);

	if (timestamp == null) {
		return null;
	}

	return <TimelineMarker theme="graphite" timestamp={timestamp} />;
};
